import React from "react";
import { Col, Row } from "reactstrap";
import { FilesForm } from "./FilesForm";

const AttachFiles = ({ bankDataList, accountId, fileList, setFileList, token, addAlert }) => {
  return (
    <Row className={"mb-3"}>
      <Col sm={12}>
        <FilesForm
          bankDataList={bankDataList}
          accountId={accountId}
          name="mainFileForm"
          fileList={fileList}
          setFileList={setFileList}
          token={token}
          addAlert={addAlert}
        />
      </Col>
    </Row>
  );
};

export default AttachFiles;
